import { Droplets, ShieldCheck, Wind, Sparkles } from 'lucide-react';
import SpiracleLogo from '../../img/spiracle_logo.png';
import CTA from '../Cta';

function GasServiceRepair() {
    return (
        <div className="chimney-repair-container">
            <section className="chimney-repair-hero">
                <div className="chimney-repair-hero-content">
                    <h1 className="chimney-repair-title">Mosquito Control Services</h1>
                    <p className="chimney-repair-subtitle">
                        Mosquitoes spread diseases like dengue, malaria and chikungunya. Our complete mosquito control program keeps your home and surroundings safe all year round.
                    </p>
                    <p className="chimney-repair-subtitle">
                        Larvicide Treatment: We treat stagnant water breeding sites where mosquitoes lay eggs, stopping the larvae from developing.
                    </p>
                    <p className="chimney-repair-subtitle">
                        Indoor Residual Spray (IRS): A safe residual spray is applied on walls and resting surfaces of mosquitoes for long lasting protection.
                    </p>
                    <p className="chimney-repair-subtitle">
                        Fogging: Specialized fogging treatment eliminates adult mosquitoes from your premises and surrounding areas.
                    </p>

                    <button className="chimney-repair-cta-btn"
                        onClick={() => (window.location.href = "tel:8530352444")}
                        style={{ cursor: "pointer" }}>
                        Get a Free Inspection
                    </button>
                </div>
            </section>

            <div className="chimney-repair-service-img">
                <img src={SpiracleLogo} alt="Mosquito Control" />
            </div>

            <section className="chimney-repair-why-choose">
                <div className="chimney-repair-why-content">
                    <h2 className="chimney-repair-heading">Why Choose Our Mosquito Control?</h2>
                    <div className="chimney-repair-why-grid">
                        <div className="chimney-repair-why-item">
                            <Droplets size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Larvicide Treatment</h3>
                            <p className="chimney-repair-description">
                                Breaks the breeding cycle by treating stagnant water and larvae breeding sites.
                            </p>
                        </div>
                        <div className="chimney-repair-why-item">
                            <Wind size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Indoor Residual Spray</h3>
                            <p className="chimney-repair-description">
                                Long lasting residual effect on walls and mosquito resting surfaces.
                            </p>
                        </div>
                        <div className="chimney-repair-why-item">
                            <Sparkles size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Fogging</h3>
                            <p className="chimney-repair-description">
                                Quick elimination of adult mosquitoes from premises and surroundings.
                            </p>
                        </div>
                        <div className="chimney-repair-why-item">
                            <ShieldCheck size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Disease Protection</h3>
                            <p className="chimney-repair-description">
                                Protects your family from dengue, malaria and other mosquito borne diseases.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="chimney-repair-process">
                <h2 className="chimney-repair-heading">Our Mosquito Control Process</h2>
                <div className="chimney-repair-process-steps">
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 1: Inspection</h3>
                        <p className="chimney-repair-step-description">
                            Identification of mosquito breeding sites, resting areas and entry points.
                        </p>
                    </div>
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 2: Larvicide Treatment</h3>
                        <p className="chimney-repair-step-description">
                            Treatment of stagnant water bodies to prevent mosquito larvae development.
                        </p>
                    </div>
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 3: IRS & Fogging</h3>
                        <p className="chimney-repair-step-description">
                            Indoor residual spray and fogging for complete elimination of adult mosquitoes.
                        </p>
                    </div>
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 4: Prevention Advice</h3>
                        <p className="chimney-repair-step-description">
                            Guidance on sanitation and water management to prevent future breeding.
                        </p>
                    </div>
                </div>
            </section>

            <CTA />
        </div>
    );
}

export default GasServiceRepair;